exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-screen {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: #fff;\n  z-index: 90;\n  padding-top: 50px;\n}\n.loading-screen h3 {\n  font-size: 26px;\n  color: #999;\n  letter-spacing: 3px;\n  text-transform: uppercase;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/shared/styles/LoadingScreen.styl
// module id = 931
// module chunks = 0 1